import { t } from "@lingui/core/macro";
import { useAtomValue, useSetAtom } from "jotai";

import { updateDiningPartySize } from "@/features/BookingWizard/DiningBookingWizard/atoms/actions/updateDiningPartySize/updateDiningPartySize";
import { getDiningPartySize } from "@/features/BookingWizard/DiningBookingWizard/atoms/selectors/getDiningPartySize/getDiningPartySize";
import { DropdownSelect } from "@whoosh/design-system/src/components/controls";
import {
  Text,
  VStack,
  Box,
} from "@whoosh/design-system/src/components/primitive";

const selectOptions = Array.from({ length: 12 }, (_, i) => ({
  value: i + 1,
  label: `${i + 1}`,
}));

export const DiningWizardPartySizeControl = () => {
  const setPartySize = useSetAtom(updateDiningPartySize);
  const currentPartySize = useAtomValue(getDiningPartySize);

  /**
   * For now this component returns null. This is because dining creates a really awkward constraint
   * around when you can change paty size. For now I'm just toggling off this control by hiding it. I'm
   * keeping it here though so when we turn it back on it's all ready.
   * I will circle back after I get the base flow working and re-enable this control, and the ability
   * to adjust group size while in the wizard. -- Trattles dec 12 2025
   */
  const hideGroupSizeControl = true;
  return hideGroupSizeControl ? null : (
    <VStack gap={4} padding={5} backgroundColor="surface-primary">
      <Text variant="mainBaseSemiBold">{t`Group Size`}</Text>
      <Box width="100%">
        <DropdownSelect<number>
          value={currentPartySize}
          placeholder={t`Select Group Size`}
          testID="dropdown-select"
          onChange={setPartySize}
          options={selectOptions}
          hideOuterMargin
        />
      </Box>
    </VStack>
  );
};
